import React, { useState } from 'react';
import { FaEdit, FaEye, FaTag, FaUser, FaToggleOn, FaToggleOff, FaChartBar, FaSpinner } from 'react-icons/fa';
//import { descargarInformeVideoEspecifico } from '../../../../components/http/Actions/EstadisticasAction';
import { descargarInformeVideoEspecifico } from '../../../../../components/http/Actions/EstadisticasAction';
const VideoShowTable = ({ videoShows, onEdit, onToggleStatus }) => {
  const [downloadingStates, setDownloadingStates] = useState({});

  // Formatear duración a minutos:segundos
  const formatDuration = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return hrs > 0 ? `${hrs}h ${mins}m` : `${mins}m`;
  };

  // Formatear fecha
  const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('es-CL', options);
  };

  // Función para obtener el comediante principal
  const getComediantePrincipal = (comediantes) => {
    return comediantes?.find(c => c.esPrincipal) || comediantes?.[0];
  };

  // Función para descargar informe del video específico
  const handleDescargarInformeVideo = async (videoId, titulo) => {
    try {
      setDownloadingStates(prev => ({ ...prev, [videoId]: true }));
      const token = localStorage.getItem('token');
      await descargarInformeVideoEspecifico(videoId, token);
    } catch (error) {
      console.error('Error al descargar informe del video:', error);
      alert(`Error al descargar el informe del video: ${error}`);
    } finally {
      setDownloadingStates(prev => ({ ...prev, [videoId]: false }));
    }
  };

  return (
    <div className="overflow-x-auto rounded-lg shadow">
      <table className="min-w-full bg-zinc-800 divide-y divide-zinc-700">
        <thead>
          <tr className="bg-zinc-700">
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              VIDEO
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              COMEDIANTES
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              TAGS
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              ESTADÍSTICAS
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-300 uppercase tracking-wider">
              ESTADO VIDEO
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-300 uppercase tracking-wider">
              ESTADO COMEDIANTE
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-300 uppercase tracking-wider">
              ESTADO DE PRIVACIDAD
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-300 uppercase tracking-wider">
              ACCIONES
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-zinc-700">
          {videoShows.length > 0 ? (
            videoShows.map((video) => {
              const comediantePrincipal = getComediantePrincipal(video.comediantes);
              const isPublished = video.habilitado && comediantePrincipal?.habilitado;
              
              return (
                <tr key={video.videoShowId} className={`hover:bg-zinc-700 transition-colors ${!isPublished ? 'opacity-60' : ''}`}>
                  {/* COLUMNA VIDEO */}
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <div className="flex-shrink-0 h-16 w-24 bg-zinc-700 rounded overflow-hidden">
                        <img 
                          src={video.imagenBlob} 
                          alt={video.titulo} 
                          className="h-full w-full object-cover"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://via.placeholder.com/150x100?text=Sin+Imagen';
                          }}
                        />
                      </div>
                      <div className="ml-4">
                        <div className="text-sm font-medium text-white line-clamp-2">
                          {video.titulo}
                        </div>
                        <div className="text-xs text-gray-400">
                          {formatDate(video.fechaEstreno)} • {formatDuration(video.duracion)}
                        </div>
                      </div>
                    </div>
                  </td>

                  {/* COLUMNA COMEDIANTES */}
                  <td className="px-6 py-4">
                    <div className="flex flex-col space-y-1">
                      {video.comediantes && video.comediantes.map((comediante, index) => (
                        <div key={index} className="flex items-center text-sm">
                          <FaUser className="mr-2 text-xs text-gray-400" />
                          <span className={`${!comediante.habilitado ? 'line-through text-gray-500' : 'text-white'}`}>
                            {comediante.nombre}
                          </span>
                          {comediante.esPrincipal && (
                            <span className="ml-2 px-2 py-0.5 bg-yellow-600 text-yellow-100 text-xs rounded-full">
                              Principal
                            </span>
                          )}
                          {!comediante.habilitado && (
                            <span className="ml-2 px-2 py-0.5 bg-red-600 text-red-100 text-xs rounded-full">
                              Deshabilitado
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  </td>

                  {/* COLUMNA TAGS */}
                  <td className="px-6 py-4">
                    <div className="flex flex-wrap gap-1">
                      {video.tags && video.tags.map((tag) => (
                        <span 
                          key={tag.tagId} 
                          className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium" 
                          style={{ 
                            backgroundColor: `${tag.colorHex}30`, 
                            color: tag.colorHex,
                            border: `1px solid ${tag.colorHex}50`
                          }}
                        >
                          {tag.nombre}
                        </span>
                      ))}
                    </div>
                  </td>

                  {/* COLUMNA ESTADÍSTICAS */}
                  <td className="px-6 py-4">
                    <div className="text-sm">
                      <div className="flex items-center text-white mb-1">
                        <FaEye className="mr-2 text-gray-400 text-xs" />
                        <span className="font-medium">{video.vistas} vistas</span>
                      </div>
                      <div className="text-xs text-gray-400">
                        {video.calificacionPromedio > 0 
                          ? `${video.calificacionPromedio.toFixed(1)} ⭐ (${video.totalCalificaciones})` 
                          : 'Sin calificaciones'}
                      </div>
                    </div>
                  </td>

                  {/* COLUMNA ESTADO VIDEO */}
                  <td className="px-6 py-4 text-center">
                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                      video.habilitado 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {video.habilitado ? 'Publicado' : 'Despublicado'}
                    </span>
                  </td>

                  {/* COLUMNA ESTADO COMEDIANTE */}
                  <td className="px-6 py-4 text-center">
                    {comediantePrincipal ? (
                      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                        comediantePrincipal.habilitado 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-red-100 text-red-800'
                      }`}>
                        {comediantePrincipal.habilitado ? 'Habilitado' : 'Deshabilitado'}
                      </span>
                    ) : (
                      <span className="text-xs text-gray-400">Sin comediante</span>
                    )}
                  </td>

                      {/* COLUMNA ESTADO Privado/Publico */}
                  <td className="px-6 py-4 text-center">
                    {video ? (
                      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                        !video.private
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-red-100 text-red-800'
                      }`}>
                        {!video.private ? 'Público' : 'Privado'}
                      </span>
                    ) : (
                      <span className="text-xs text-gray-400">Sin estado</span>
                    )}
                  </td>

                  {/* COLUMNA ACCIONES */}
                  <td className="px-6 py-4 whitespace-nowrap text-right">
                    <div className="flex justify-end items-center space-x-2">
                      {/* Botón Editar */}
                      <button
                        onClick={() => onEdit(video)}
                        className="p-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors"
                        title="Editar video"
                      >
                        <FaEdit className="text-sm" />
                      </button>

                      {/* Botón Toggle Status */}
                      <button
                        onClick={() => onToggleStatus(video)}
                        className={`p-2 rounded-lg transition-colors ${
                          video.habilitado 
                            ? 'bg-orange-600 text-white hover:bg-orange-700' 
                            : 'bg-green-600 text-white hover:bg-green-700'
                        }`}
                        title={video.habilitado ? "Despublicar video" : "Publicar video"}
                      >
                        {video.habilitado ? <FaToggleOff className="text-sm" /> : <FaToggleOn className="text-sm" />}
                      </button>

                      {/* NUEVO: Botón Descargar Informe */}
                      <button
                        onClick={() => handleDescargarInformeVideo(video.videoShowId, video.titulo)}
                        disabled={downloadingStates[video.videoShowId]}
                        className="p-2 rounded-lg bg-purple-600 text-white hover:bg-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        title="Descargar informe del video"
                      >
                        {downloadingStates[video.videoShowId] ? (
                          <FaSpinner className="text-sm animate-spin" />
                        ) : (
                          <FaChartBar className="text-sm" />
                        )}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="7" className="px-6 py-12 text-center text-gray-400">
                No se encontraron videos que coincidan con la búsqueda.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default VideoShowTable;